import PaymentMethod from './PaymentMethod';

export {PaymentMethod};
export default PaymentMethod;
